import "babel-polyfill";
import React from 'react';
import Cropper from './cropper';
import CustomizeMessage from './customizeMessage';
import ImageHelpers from '../util/aws';

import Accordion from '../util/accordion';

class CustomLabelContainer extends React.Component {
  state = {
    loadingPreview: false,
    customText: "",
    strippedText: "",
    emojiEntities: [],
    emojiEntitiesJSON: "[]",
    uploadedImageURL: null,
    generatedPreviewURL: null,
    croppedImageBase64: null,
    imageUploadFileType: null,
    fileKey: null,
    errorMsg: ""
  }

  updateText = (text, strippedText, emojiEntities,  cb) => {
    this.disableAddToCart(true)

    emojiEntities = emojiEntities.map((e) => {
      const match = e.url.match(/[^\/]*\.png/)
      e["file"] = match ? match[0] : null
      return e
    })

    this.setState({
      customText: text,
      strippedText: strippedText,
      emojiEntities: emojiEntities,
      emojiEntitiesJSON: JSON.stringify(emojiEntities)
    })

    if (this.state.croppedImageBase64) {
      this.generatePreview(null, text)
    } 

    cb();
  }

  updateCroppedBase64 = (base64, type) => {
    this.disableAddToCart(true)
    this.setState({
      croppedImageBase64: base64,
      imageUploadFileType: type
    })
  }

  // _generateLabel = async (base64, text) => {
  //   const txt = text || this.state.customText
  //   const img = base64 || this.state.croppedImageBase64
  //   const type = this.state.imageUploadFileType
  //   if (img) {
  //     const res = await fetch(img)
  //     const blob = await res.blob()
  //     const {url, fileKey} = await ImageHelpers.signAndUpload(blob, type, "personalizedEndpoint")

  //     const label = await ImageHelpers.generateLabel(
  //       txt, 
  //       url
  //     )
  //     this.setState({ generatedLabelURL: label.image_url, loadingPreview: false })
  //     this.disableAddToCart(false)
  //     // this._replaceProdPreview(label.image_url)
  //   }
  // }

  generatePreview = async (base64, text) => {
    this.setState({loadingPreview: true})
    const txt = text || this.state.customText
    const img = base64 || this.state.croppedImageBase64
    const type = this.state.imageUploadFileType
    if (img) {
      this._prodPreviewLoading();
      const res = await fetch(img)
      const blob = await res.blob()

      try {
        const { url, fileKey } = await ImageHelpers.signAndUpload(blob, type, "personalizedEndpoint")

        this.setState({ uploadedImageURL: url, fileKey: fileKey })

        const preview = await ImageHelpers.generatePreview(txt, url, this.state.strippedText, this.state.emojiEntitiesJSON)
        this._replaceProdPreview(preview.image_url)
        this.setState({ generatedPreviewURL: preview.image_url, loadingPreview: false })

      } catch (e) {
        this.setState({ 
          loadingPreview: false,
          errorMsg: "Sorry, please try saving again."
        })
        this._stopPreviewLoading()
        return null
      }
      this.disableAddToCart(false)
    }
  }

  disableAddToCart = (disabledBool)  => {
    $("#add-to-cart .submit-wrapper input").prop("disabled", disabledBool);
  }

  _prodPreviewLoading = () => {
    let showcase = $("#product-area .showcase")
    showcase.find(".spinner").remove()
    showcase.find("img").addClass("blur")
    showcase.find(".wrap").append(`
     <div class="preview-spinner">
      <div class="cube1"></div>
      <div class="cube2"></div>
    </div> 
    `);
  }

  _stopPreviewLoading = () => {
    let showcase = $("#product-area .showcase")
    showcase.find(".spinner").remove()
    showcase.find("img").removeClass("blur")
    showcase.find(".wrap .preview-spinner").remove()
    $(".Collapsible__trigger").get(0).click()
  }

  _replaceProdPreview = (imageUrl) => {
    let showcase = $("#product-area .showcase")
    let fullView = $("section.fullscreen-product-viewer")
    let $loadingImage = $("<img>").attr("src", imageUrl)
    $loadingImage.load(function() {
      showcase.find(".preview-spinner").remove()
      showcase.find("img").attr("src", $(this).attr("src"))
      fullView.find(".wrap img").attr("src", $(this).attr("src"))
      showcase.find("img").removeClass("blur").addClass("personalized")
    })
  }

  HiddenFields = () => {
    return (
      <React.Fragment>
      <input hidden
        id="uploaded-image"
        name="properties[_uploaded_image]"
        type="text"
        value={this.state.uploadedImageURL} />
      <input hidden
        id="generated-preview"
        name="properties[_generated_preview]"
        type="text"
        value={this.state.generatedPreviewURL} />
      <input hidden
        type="text"
        id="custom-text"
        name="properties[custom_text]"
        value={this.state.customText} />
      <input hidden
        id="stripped-text"
        name="properties[_stripped_text]"
        type="text"
        value={this.state.strippedText} />
      <input hidden
        id="emoji-entities"
        name="properties[_emoji_entities_string]"
        type="text"
        value={this.state.emojiEntitiesJSON} />
      </React.Fragment>
    )
  }

  render() {
    return (
      <React.Fragment>
  
      <this.HiddenFields />

      <Accordion closeable={true}>
        <div data-trigger={this.props.translations["choose-image"]}>
          <Cropper 
            generatePreview={this.generatePreview}
            updateCroppedBase64={this.updateCroppedBase64}
            translations={this.props.translations}
            errorMsg={this.state.errorMsg} />
        </div>

        <div data-trigger={this.props.translations["add-message"]}>
            <CustomizeMessage 
              loadingPreview={this.state.loadingPreview}
              disableAddToCart={this.disableAddToCart}
              customText={this.state.customText}
              strippedText={this.state.strippedText}
              emojiEntitiesJSON={this.state.emojiEntitiesJSON}
              updateText={this.updateText} />
        </div>
      </Accordion>
      </React.Fragment> 
    );
  }
}

export default CustomLabelContainer; 